import React, {useEffect, useRef} from 'react';
import * as PropTypes from "prop-types";
import HeaderLogo from "./HeaderLogo";
import HeaderBurger from "./HeaderBurger";
import HeaderMenu from "./HeaderMenu";
import classNames from "classnames";
import {node} from "prop-types";
import stylesCH from "../../gui/customHeader/CustomHeader.module.scss";
import {usePanel} from "../../../../redux/reducer/panel";
import styles from "./Header.module.scss"

export default function Header({burger = true, logo, logo2, menu, className, children} = {}) {
  const {burger:showBurger} = usePanel();
  const headerRef = useRef();

  useEffect(() => {
    let prevPosition = 100;
    const {classList} = headerRef.current;

    const togglePosition = () => {
      var currentPosition = window.pageYOffset || document.documentElement.scrollTop;
      if (prevPosition > currentPosition) {
        classList.remove(stylesCH.customHeader_hide);
      } else {
        classList.add(stylesCH.customHeader_hide);
      }
      prevPosition = currentPosition;
    };

    window.addEventListener('resize', togglePosition);
    return ()=>{
      window.removeEventListener('resize',togglePosition)
    }
    // togglePosition();
  }, []);


  return (
    <header className={classNames(styles.header, stylesCH.customHeader, className,{
      [stylesCH.customHeader_show]:showBurger
    } )} ref={headerRef}>
      <div className={classNames('header__block',stylesCH.customHeader__block)}>
        <div className={classNames( stylesCH.customHeader__logos)}>
          {logo && <HeaderLogo {...logo} key={`logo-1`} width={40} height={40} />}
          <span className={stylesCH.customHeader__logosLine}/>
          {logo2 && <HeaderLogo {...logo2} key={`logo-2`} width={80} height={40}/>}
        </div>
        {menu ? <HeaderMenu menu={menu}/> : null}
        {burger ? <HeaderBurger/> : null}
        {children}
      </div>
    </header>

  );
}

Header.propTypes = {
  /*
    В зависмости от параметра бургер для меню либо добавляется либо нет
  */
  burger: PropTypes.bool,
  /*
    Компонент, который будет добавлятся в logo
  */
  logo: PropTypes.element,
  /*
    Компонент, который будет добавлятся в качестве меню
  */
  menu: PropTypes.element,

  children: node
};
